module.exports = __webpack_public_path__ + "static/media/h2_who_bw.bd6dbaf0.webp";